import { configureStore } from '@reduxjs/toolkit';
import chatReducer from '../components/chat/chatSlice';
import loginReducer from '../components/login/loginSlice';

export const store = configureStore({
  reducer: {
    chat: chatReducer,
    login: loginReducer
  },
});